import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import SystemInfoLayout from '../../layouts/SystemInfoLayout';
import getSystemInfoAction from '../../redux/actions/getSystemInfo';
import {
  addSystemOrDeviceAction,
  clearState,
} from '../../redux/actions/addSystemOrDevice';
import { editSystemOrDeviceAction } from '../../redux/actions/editSystemOrDevice';
import addSystemOrDeviceSchema from '../../_helpers/validator/addSystemOrDeviceSchema';
import deleteSystemOrDeviceAction from '../../redux/actions/deleteSystemOrDevice';
import { displayToast } from '../../_helpers/commonFunctions';
import DeleteConfirmationModal from '../../components/DeleteConfirmationModal';
import {
  resetSelectedCustomer,
  setSubMenuVisibility,
} from '../../redux/actions/setSelectedCustomer';
import Loader from '../../components/Loader';
import { reportCat } from '../../redux/actions/reportCategory';
import SetIsPromptAction from '../../redux/actions/isPromptAction';

/**
 * View component for System Information for particular customer.
 */
class SystemInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      systemInfo: {
        reportType: '',
        systemDeviceType: '',
        type: '',
        quantity: null,
        otherDeviceType: '',
      },
      systemInfoErrors: {
        reportType: '',
        systemDeviceType: '',
        type: '',
        quantity: '',
        otherDeviceType: '',
      },
      systemInfoId: '',
      isDeleteConfirmModalVisible: false,
      showSystemInfo: false,
      isClassVisible: {},
    };

    this.baseState = JSON.stringify(this.state);
  }

  /**
   * Resets local state.
   */
  resetState = () => {
    const newState = JSON.parse(this.baseState);
    this.setState(newState);
  };

  /**
   * Called on on change for adding system information.
   */
  setSystemInfo = (dropDownName, dropDownVal) => {

    const { systemInfo } = this.state;
    if (dropDownName === 'reportType') {
      systemInfo.systemDeviceType = '';
      systemInfo.type = '';
      systemInfo.showQty =(dropDownVal === 'Pump') ? false: true;
    } else if (dropDownName === 'systemDeviceType') {
      systemInfo.type = '';
    } else if (dropDownName === 'type' && dropDownVal !== 'Other') {
      systemInfo.otherDeviceType = '';
    }
    systemInfo[dropDownName] = dropDownVal;
    this.setState({ systemInfo });
    this.props.SetIsPromptAction(true);
  };

  /**
   * Resets to error object.
   */
  resetErrors = () => {
    this.setState({
      systemInfoErrors: { ...JSON.parse(this.baseState).systemInfoErrors },
    });
  };

  /**
   * Called for updating errors while adding system info.
   */
  handleErrors = (err) => {
    const { systemInfoErrors } = { ...this.state };
    err.inner.forEach((item) => {
      systemInfoErrors[`${item.path}`] = item.message;
    });
    this.setState({ systemInfoErrors });
  };

  /**
   * Called on saving new system information.
   */
  addSystemOrDevice = (cb) => {
    this.resetErrors();
    const { buildingInfoId } = this.props;
    const { systemInfo,systemInfoErrors } = { ...this.state };
    delete systemInfo.showQty;
    if (systemInfo.reportType === 'Pump') {
      systemInfo.quantity = 1;
      
    }
    systemInfo.quantity = Number(systemInfo.quantity);
    addSystemOrDeviceSchema.validate(systemInfo, { abortEarly: false }).then(
      () => {
        const systemInfoOther = { ...systemInfo };
        if (systemInfoOther.type !== 'Other') {
          delete systemInfoOther.otherDeviceType;
        }
        this.props.addSystemOrDeviceAction(buildingInfoId, systemInfoOther);
        this.setState(
          {
            systemInfoErrors: {
              ...JSON.parse(this.baseState).systemInfoErrors,
            },
          },
          () => cb && cb()
        );
      },
      (err) => this.handleErrors(err)
    );
  };

  /**
   * Called on editing system information.
   */
  editSystemOrDevice = (updatedSystemInfo, callback) => {
    const { buildingInfoId } = this.props;
    const editData = {
      systemInfoId: updatedSystemInfo._id,
      reportType: updatedSystemInfo.reportType,
      systemDeviceType: updatedSystemInfo.systemDeviceType,
      type: updatedSystemInfo.type,
      quantity: updatedSystemInfo.quantity,
    };
    this.props.editSystemOrDeviceAction(buildingInfoId, editData);
    callback && callback();
  };

  setSelectedSystemInfoId = (selectedId) => {
    this.setState({
      systemInfoId: selectedId,
      isDeleteConfirmModalVisible: true,
    });
  };

  /**
   * Deleting record of particular system information.
   */
  deleteSystemOrDevice = () => {
    const { buildingInfoId } = this.props;
    const { systemInfoId } = this.state;
    this.props.deleteSystemOrDeviceAction(buildingInfoId, systemInfoId);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selectedCustomerId !== this.props.selectedCustomerId) {
      this.props.getSystemInfoAction(this.props.selectedCustomerId);
    }
    if (
      this.props.isAddDeviceSuccess &&
      prevProps.isAddDeviceSuccess !== this.props.isAddDeviceSuccess
    ) {
      this.props.clearState();
      this.props.getSystemInfoAction(this.props.selectedCustomerId);
      this.props.reportCat();
      this.setState({
        systemInfo: { ...JSON.parse(this.baseState).systemInfo },
      });
      displayToast(this.props.addDeviceSuccessMessage, 'success');
    }
    if (
      this.props.isEditDeviceSuccess &&
      prevProps.isEditDeviceSuccess !== this.props.isEditDeviceSuccess
    ) {
      this.props.getSystemInfoAction(this.props.selectedCustomerId);
      displayToast('System information updated successfully', 'success');
    }
    if (
      this.props.editDeviceErrorMessage &&
      prevProps.editDeviceErrorMessage !== this.props.editDeviceErrorMessage
    ) {
      displayToast(this.props.editDeviceErrorMessage, 'error');
    }
    if (
      this.props.addDeviceErrorMessage &&
      (prevProps.addDeviceErrorMessage !== this.props.addDeviceErrorMessage ||
        (this.props.addDeviceErrorMessage &&
          !prevProps.isAddDeviceFetching &&
          this.props.isAddDeviceFetching !== prevProps.isAddDeviceFetching))
    ) {
      displayToast(this.props.addDeviceErrorMessage, 'error');
      this.setState({
        systemInfo: { ...JSON.parse(this.baseState).systemInfo },
      });
      setTimeout(() => {
        this.props.clearState();
        this.props.getSystemInfoAction(this.props.selectedCustomerId);
        this.props.reportCat();
      }, 100);
    }
    if (this.props.deleteSuccessMessage) {
      displayToast(this.props.deleteSuccessMessage, 'success');
      this.props.clearState();
      this.props.getSystemInfoAction(this.props.selectedCustomerId);
    } else if (this.props.deleteErrorMessage) {
      displayToast(this.props.deleteErrorMessage, 'error');
    }
  }

  componentDidMount() {
    this.props.getSystemInfoAction(this.props.selectedCustomerId);
    this.props.setSubMenuVisibility(true);
  }

  infoSystemInfo = (willTooltipShow) => {
    if (this.state.showSystemInfo !== willTooltipShow) {
      this.setState({ showSystemInfo: willTooltipShow });
    }
  };

  // Handle Mobile Table View
  setClassVisibility = (employeeId) => {
    const isClassVisible = {};
    if (Object.keys(this.state.isClassVisible)[0] === employeeId) {
      isClassVisible[`${employeeId}`] =
        !this.state.isClassVisible[`${employeeId}`];
    } else {
      isClassVisible[`${employeeId}`] = true;
    }
    this.setState({ isClassVisible });
  };

  render() {
    const {
      systemInfoErrors,
      isDeleteConfirmModalVisible,
      showSystemInfo,
      isClassVisible,
    } = this.state;
    const {
      isAddDeviceFetching,
      isEditDeviceFetching,
      isDeleteApiFetching,
      reportCategoryList,
    } = this.props;

    return (
      <div>
        {(isAddDeviceFetching ||
          isEditDeviceFetching ||
          isDeleteApiFetching) && <Loader />}
        {isDeleteConfirmModalVisible && (
          <DeleteConfirmationModal
            handleClickCancel={() =>
              this.setState({ isDeleteConfirmModalVisible: false })
            }
            handleClickCross={() => {
              this.setState({ isDeleteConfirmModalVisible: false });
            }}
            handleClickDelete={() =>
              this.setState({ isDeleteConfirmModalVisible: false }, () =>
                this.deleteSystemOrDevice()
              )
            }
            deleteMessage={this.props.intl.formatMessage({
              id: 'Are you sure you want to delete this System Info?',
              defaultMessage: 'Are you sure you want to delete this System Info?',
            })}
          />
        )}
        <SystemInfoLayout
          reportCategoryList={reportCategoryList}
          systemInfo={this.state.systemInfo}
          systemInfoList={this.props.systemInfoList}
          systemInfoErrors={systemInfoErrors}
          isFetching={this.props.isFetching}
          hasMoreItems={false}
          setSystemInfo={this.setSystemInfo}
          handleClickSave={this.addSystemOrDevice}
          handleEditSave={this.editSystemOrDevice}
          resetState={this.resetState}
          setSelectedSystemInfoId={this.setSelectedSystemInfoId}
          resetErrors={this.resetErrors}
          reportGridShow={this.props.reportGridShow}
          callBack={() => this.props.setSubMenuVisibility(false)}
          showSystemInfo={showSystemInfo}
          infoSystemInfo={this.infoSystemInfo}
          isClassVisible={isClassVisible}
          setClassVisibility={this.setClassVisibility}
          SetIsPromptAction={this.props.SetIsPromptAction}
          isRenderedInReports={this.props.isRenderedInReports}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  getSystemInfo,
  setSelectedCustomer,
  addSystemOrDevice,
  editSystemOrDevice,
  deleteSystemOrDevice,
  reportCategory,
}) => ({
  selectedCustomerId: setSelectedCustomer.selectedCustomerId,
  systemInfoList: getSystemInfo.systemInfoList,
  buildingInfoId: getSystemInfo.systemInfoId,
  isFetching: getSystemInfo.isFetching,
  isAddDeviceSuccess: addSystemOrDevice.isSuccess,
  isAddDeviceFetching: addSystemOrDevice.isFetching,
  isEditDeviceSuccess: editSystemOrDevice.isSuccess,
  isEditDeviceFetching: editSystemOrDevice.isFetching,
  editDeviceErrorMessage: editSystemOrDevice.errorMessage,
  isDeleteApiFetching: deleteSystemOrDevice.isFetching,
  deleteSuccessMessage: deleteSystemOrDevice.success,
  deleteErrorMessage: deleteSystemOrDevice.error,
  reportGridShow: setSelectedCustomer.reportLogoList,
  reportCategoryList: reportCategory.reportData,
  addDeviceSuccessMessage: addSystemOrDevice.success,
  addDeviceErrorMessage: addSystemOrDevice.error,
});

SystemInfo.propTypes = {
  selectedCustomerId: PropTypes.string,
  systemInfoList: PropTypes.array,
  getSystemInfoAction: PropTypes.func,
  isFetching: PropTypes.bool,
  addSystemOrDeviceAction: PropTypes.func,
  editSystemOrDeviceAction: PropTypes.func,
  buildingInfoId: PropTypes.string,
  deleteSystemOrDeviceAction: PropTypes.func,
  clearState: PropTypes.func,
  isAddDeviceSuccess: PropTypes.bool,
  isEditDeviceSuccess: PropTypes.bool,
  isEditDeviceFetching: PropTypes.bool,
  editDeviceErrorMessage: PropTypes.string,
  isDeleteApiFetching: PropTypes.bool,
  deleteSuccessMessage: PropTypes.string,
  deleteErrorMessage: PropTypes.string,
  isAddDeviceFetching: PropTypes.bool,
  setSelectedCustomer: PropTypes.func,
  resetSelectedCustomer: PropTypes.func,
  reportGridShow: PropTypes.bool,
  reportCategoryList: PropTypes.object,
  reportCat: PropTypes.func,
  setSubMenuVisibility: PropTypes.func,
  SetIsPromptAction: PropTypes.func,
  addDeviceSuccessMessage: PropTypes.string,
  addDeviceErrorMessage: PropTypes.string,
  isRenderedInReports: PropTypes.bool,
  intl: PropTypes.object,
};

export default connect(mapStateToProps, {
  getSystemInfoAction,
  addSystemOrDeviceAction,
  editSystemOrDeviceAction,
  deleteSystemOrDeviceAction,
  clearState,
  reportCat,
  resetSelectedCustomer,
  setSubMenuVisibility,
  SetIsPromptAction,
})(injectIntl(SystemInfo));
